import { Header, VStack } from 'tio-ui/components/layout';
import { t } from 'ember-intl';
import Alert from 'tio-ui/components/alert';
import EmployeesCreateEmployee from 'tio-employee/components/employees/create-employee';
import TioPageBreadcrumbs from 'tio-common/components/tio/page/breadcrumbs';
import type EmployeeModel from 'tio-common/models/employee';
import type { TOC } from '@ember/component/template-only';

interface S {
  Args: {
    model: EmployeeModel;
  };
}
const tmpl: TOC<S> = <template>
  <VStack>
    <Header>
      {{t "partner.employee.create_employee"}}
    </Header>
    <TioPageBreadcrumbs as |b|>
      <b.crumb
        class="relative! inline-block!"
        @route="authenticated.admin.employees.index"
        @label="Employees"
      />
      <b.crumb
        class="relative! inline-block!"
        @route="authenticated.admin.employees.add"
        @label={{t "partner.employee.create_employee"}}
      />
    </TioPageBreadcrumbs>
    <Alert @intent="primary">
      {{t "partner.employee.alert_info" htmlSafe=true}}
    </Alert>
    <EmployeesCreateEmployee @model={{@model}} />
  </VStack>
</template>;

export default tmpl;
